<template>
  <div id="app">
    <Nav v-if="$route.fullPath.indexOf('/login') === -1"/>
    <router-view/>
  </div>
</template>

<script>
import Nav from "@/components/nav"
import contents from './components/content/contents'

export default {
  name: 'App',
  components: {Nav},
  created() {
    contents.refreshNetStatus()// 判断是否为品沃环境
  }
}
</script>

<style>
@import './styles/index.less';

html, body {
  margin: 0;
  padding: 0;
  /*background: #F8F8F8*/
  background:
}

</style>



// WEBPACK FOOTER //
// src/App.vue